import { motion } from 'framer-motion';
import styled from 'styled-components';

import { colors } from 'utils/styles/theme';

interface SocialMediaTileWrapperProps {
  hoverTextColor?: string;
}

export const SocialMediaTileWrapper = styled.div<SocialMediaTileWrapperProps>`
  display: flex;
  flex-direction: column;

  align-items: start;

  h5 {
    margin-bottom: 12px;
    a {
      background-image: ${({ hoverTextColor }) =>
        `linear-gradient(transparent calc(100% - 2px), ${
          colors[hoverTextColor] ?? hoverTextColor ?? 'white'
        } 22px)`};
      background-repeat: no-repeat;
      background-size: 0 100%;
      background-position: 100% 100%;
      transition: background-size 500ms, color 500ms;
    }
  }

  &:hover {
    h5 a {
      background-size: 100% 100%;
      background-position: 0 100%;

      ${({ hoverTextColor }) =>
        hoverTextColor?.length &&
        `color: ${colors[hoverTextColor] ?? hoverTextColor}`};
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  position: relative;

  margin-bottom: 16px;
`;

export const Image = styled(motion.img)`
  width: 100%;
  pointer-events: none;
`;

export const PostInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;

  margin-bottom: 12px;
`;

export const LeftSideSocialWrapper = styled.div`
  display: inherit;

  small {
    margin-left: 8px;
  }
`;
